import { useState, useRef, useEffect } from 'react'
import './MobileSwipeContainer.css'

export default function MobileSwipeContainer({ children, activeIndex, onIndexChange }) {
  const containerRef = useRef(null)
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const [swiping, setSwiping] = useState(false)
  const [swipeOffset, setSwipeOffset] = useState(0)

  const minSwipeDistance = 50

  const onTouchStart = (e) => {
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
    setSwiping(true)
  }

  const onTouchMove = (e) => {
    if (!touchStart) return
    const currentTouch = e.targetTouches[0].clientX
    const diff = currentTouch - touchStart
    setTouchEnd(currentTouch)

    // Limit swipe offset and add resistance at edges
    const maxOffset = window.innerWidth * 0.4
    const clampedDiff = Math.max(-maxOffset, Math.min(maxOffset, diff))
    setSwipeOffset(clampedDiff)
  }

  const onTouchEnd = () => {
    setSwiping(false)
    setSwipeOffset(0)

    if (!touchStart || !touchEnd) return

    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance

    if (isLeftSwipe && activeIndex < 2) {
      onIndexChange(activeIndex + 1)
      // Haptic feedback
      if (navigator.vibrate) navigator.vibrate(10)
    }
    if (isRightSwipe && activeIndex > 0) {
      onIndexChange(activeIndex - 1)
      if (navigator.vibrate) navigator.vibrate(10)
    }
  }

  return (
    <div
      className="mobile-swipe-container"
      ref={containerRef}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div
        className={`mobile-swipe-track ${swiping ? 'swiping' : ''}`}
        style={{
          transform: `translateX(calc(-${activeIndex * 100}% + ${swipeOffset}px))`,
        }}
      >
        {children}
      </div>

      {/* Swipe indicators */}
      <div className="swipe-indicators">
        {[0, 1, 2].map(i => (
          <button
            key={i}
            className={`swipe-dot ${i === activeIndex ? 'active' : ''}`}
            onClick={() => onIndexChange(i)}
          />
        ))}
      </div>

      {/* Edge hints */}
      {activeIndex > 0 && (
        <div className="swipe-hint left">
          <span>&#8249;</span>
        </div>
      )}
      {activeIndex < 2 && (
        <div className="swipe-hint right">
          <span>&#8250;</span>
        </div>
      )}
    </div>
  )
}
